import { render, staticRenderFns } from "./MetricasAniversario.vue?vue&type=template&id=fb45f39c&scoped=true"
import script from "./MetricasAniversario.vue?vue&type=script&lang=js"
export * from "./MetricasAniversario.vue?vue&type=script&lang=js"
import style0 from "./MetricasAniversario.vue?vue&type=style&index=0&id=fb45f39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb45f39c",
  null
  
)

export default component.exports